import { FileWarningIcon } from "@ala/icons/files/outline-dual";

interface NotFoundProps {
  title?: string;
  description?: string;
  children?: React.ReactNode;
}

export const NotFound = ({
  title = "Page not found",
  description = "The page you're looking for doesn't exist or has been moved.",
  children,
}: NotFoundProps) => {
  return (
    <div className="h-svh w-full px-4 xs:px-6">
      <div className="mx-auto flex size-full max-w-[300px] flex-col items-center justify-center gap-8 text-center text-contrast-900">
        <FileWarningIcon className="size-32" secondary="fill-contrast-200 text-white" primary="fill-red-600 text-white" />

        <h1 className="text-[32px] leading-tight font-normal uppercase">{title}</h1>
        <p className="text-contrast-400">{description}</p>
        {children}
      </div>
    </div>
  );
};

export default NotFound;
